import { createGlobalStyle } from "styled-components";

export const theme = {
  // Base Colors
  dark_grey: "#262626",
  xdark_grey: "#373737",
  med_grey: "#b8bac5",
  xmed_grey: "#92949d",
  light_grey: "#f2f3f8",
  xlight_grey: "#f9f9fb",

  // Theme Accent Colors
  accent_green: "#8fdcdf",
  accent_blue: "#007cb1",
  accent_navy: "#004473",

  // Gravoc Colors
  primary: "#424874",
  blue_g: "#50accb",
  green_g: "#35d687",
  grey_g: "#d8dbe2",
  gold_g: "#ffcd3f",
  red_g: "#fe703f",
  purple_g: "#4c53d6",

  dark_blue: "#202832",
  dark_navy: "#1a2129",
  dark_input: "#2e3844",

  navbar_height: "70px",
  sidebar_width: "225px"
};

export const GlobalStyles = createGlobalStyle`
html {
  scroll-behavior: smooth;
  // &::-webkit-scrollbar {
  //   width: 0;
  // }
}

// ::-webkit-scrollbar {
//     width: 0px !important;
//     background: transparent !important;
//   }

p,
body {
  font-family: "Metropolis", sans-serif;
}

body {
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_blue : "#f5f6fa"} !important;
  max-width: 100%;
  height: 100%;  
}

::-webkit-scrollbar {
  width: 6px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  background: ${(props) => props.theme.blue_g};
  border-radius: 25px;
}

a { 
  text-decoration: none !important;
  color: ${(props) => props.theme.blue_g};
}

* {
  outline: none !important;
}

.row {
  margin: 0.5em 0px;
}

.vertical-center {
  display: flex;
  justify-content: center;
  align-items: center;
  &.-full {
    height: 100vh;
  }
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.error {
  
}

.flex {
  display: flex;
  &.-end {
    justify-content: flex-end;
  }
  &.-center {
    justify-content: center;
    align-items: center;
  }
  &.-center-h {
    justify-content: center;
  }
  &.-space-between {
    justify-content: space-between
  }
  &.-center-v {
    align-items: center;
  }
  &.-full {
    height: 70vh;
  }
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.pd-20 {
  padding-bottom: 20px !important;
}

.text-right {
  text-align: right;
}

h1,
h2,
h3 {
  font-family: "Metropolis";
}

#page-wrap {
  min-height: 97vh;
  margin: 0 0 0 0;
  padding-top: 10px;
}

.-loading {
  .-loading-inner {
    height: auto !important;
    margin: 0 auto;
  }
}
.full-width {
  width : 100% !important;
  div:first-child {
    width : 100% !important;
  }
}
`;

export default {
  GlobalStyles,
  theme
};
